import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SpotActions, authActions } from "../../../../../redux/actions";
import { useTranslation } from "react-i18next";
import {
  Directions,
  translationConstants,
  viewPathConstants,
} from "../../../../../constants";
import { googleLocationUrl } from "../../../../../system";
import { useNavigate } from "react-router-dom";
import get_directions from "../../../../../assets/images/icon/get_directions.svg";

const General = ({ eventData }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [location, setLocation] = useState();
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [city, setCity] = useState();
  const cities = useSelector((state) => state.LoginReducer.cities);
  const navigate = useNavigate();

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, [dispatch, eventData]);

  useEffect(() => {
    const findCity = cities?.find((c) => c.id === eventData?.cityId);
    setCity(findCity);
  }, [cities, eventData]);

  useEffect(() => {
    setLat(eventData?.spotInfo?.lat || eventData?.lat);
    setLong(eventData?.spotInfo?.long || eventData?.long);
  }, [eventData, city?.lat, city?.long]);

  const googleMapsLink = googleLocationUrl(lat, long);

  return (
    <>
      {eventData && cities && (
        <div className="px-3 py-3 text-black">
          <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-5">
            <div>
              <h5 className="fw-bolder">{t(translationConstants.LOCATION)}:</h5>
              <a
                href={
                  eventData?.spotInfo
                    ? undefined
                    : `https://maps.google.com/?q=${eventData?.lat},${eventData?.long}`
                }
                onClick={(e) => {
                  if (eventData?.spotInfo) {
                    e.preventDefault(); // Prevent default link behavior
                    navigate(viewPathConstants.VIEW_SPOT_DETAIL, {
                      state: {
                        centerId: eventData?.spotInfo?.id,
                      },
                    });
                  }
                }}
                target="_blank"
                className="font-16 center-card-view-detail-link d-flex gap-1 align-items-center"
              >
                <img src={get_directions} alt="get directions icon" />
                {direction === Directions.rtl
                  ? eventData?.spotInfo?.arabicSpotName ||
                    eventData?.spotInfo?.spotName
                  : eventData?.spotInfo?.spotName}
                {direction === Directions.rtl
                  ? city?.arabicName || city?.name
                  : city?.name}
              </a>
            </div>
            {eventData?.totalFee && (
              <div>
                <h5 className="fw-bolder">
                  {t(translationConstants.REGISTRATION_FEES)}:
                </h5>
                <span className="font-14">
                  {translationConstants.SAR} {eventData?.totalFee}
                </span>
              </div>
            )}
            <div>
              <h5 className="fw-bolder">
                {t(translationConstants.maximum_participants)}:
              </h5>
              <span className="font-14">
                {eventData?.maximumParticipantsAllowed}
              </span>
            </div>
          </div>

          {eventData?.providedServices && (
            <>
              <h5 className="mt-40px fw-bolder">
                {`${t(translationConstants.services)}:`}
              </h5>
              {eventData?.providedServices
                ?.split(",")
                .map((service, index, array) => (
                  <React.Fragment key={index}>
                    <span className="font-14">{t(service.trim())}</span>
                    {index < array.length - 1 && <span>, </span>}
                  </React.Fragment>
                ))}
            </>
          )}

          <h5 className="mt-40px fw-bolder">
            {`${t(translationConstants.DESCRIPTION)}:`}
          </h5>
          <p className="mt-2 text-14 w-75 text-wrap text-break">
            {direction === Directions.rtl
              ? eventData?.arabicDescription
                ? eventData?.arabicDescription
                : eventData?.description
              : eventData?.description}
          </p>
        </div>
      )}
    </>
  );
};

export default General;
